import {
  GET_LIST_OF_PARKS_SUCCESS,
  GET_LIST_OF_PARKS_FAILURE,
  FETCH_LIST_OF_PARKS,
  LOG_OUT,
} from "../constant";

const initState = {
  success: false,
  error: "",
  parks: [],
  isFetched: false,
};

export default function Parks(state = initState, action) {
  switch (action.type) {
    case FETCH_LIST_OF_PARKS:
      return {
        success: false,
        error: "",
        parks: [],
        isFetched: false,
      };
    case GET_LIST_OF_PARKS_SUCCESS:
      return {
        success: action.payload.success,
        error: "",
        parks: action.payload.parks,
        isFetched: true,
      };
    case GET_LIST_OF_PARKS_FAILURE:
      return {
        error: action.payload.error,
        parks: [],
        success: false,
        isFetched: true,
      };
    case LOG_OUT:
      return {
        initState,
      };
    default:
      return state;
  }
}
